export enum EAUTH_STEPS {
  PHONE = 1,
  OTP = 2,
}

export enum ELOGIN_OPTIONS {
  SMS = 'phone_number',
  WHATSAPP = 'whatsapp',
}

export enum EFORMATTED_LOGIN_OPTIONS {
  SMS = 'SMS',
  WHATSAPP = 'WhatsApp',
}
